module.exports = __webpack_public_path__ + "static/media/delete.2a0c7843.svg";